import React from 'react';
import { type FallbackProps } from 'react-error-boundary';

import ErrorBoundary from 'components/errorBoundary/ErrorBoundary';
import GeneralErrorBoundaryUI from 'components/errorBoundary/GeneralErrorBoundaryUI';

/**
 * withErrorBoundary는 컴포넌트를 에러바운더리로 감싸주는 HOC
 */
function withErrorBoundary<T extends object>(
  WrappedComponent: React.ComponentType<T>,
  fallbackComponent: React.ComponentType<FallbackProps> = GeneralErrorBoundaryUI
) {
  const ComponentWithErrorBoundary = (props: T) => (
    <ErrorBoundary fallbackComponent={fallbackComponent}>
      <WrappedComponent {...props} />
    </ErrorBoundary>
  );

  ComponentWithErrorBoundary.displayName = `withErrorBoundary(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return ComponentWithErrorBoundary;
}

export default withErrorBoundary;
